import { Field } from '@approvalmax/ui';
import { ExchangeRateWithUpdate } from 'pages/requestForm/components/ExchangeRateWithUpdate/ExchangeRateWithUpdate';
import styled from 'styled-components';

import { CurrencyDisclaimerLegacy } from '../../../components/(legacy)/CurrencyDisclaimerLegacy/CurrencyDisclaimerLegacy';

export const Content = styled.div`
    display: flex;
    margin-right: -20px;
`;

export const VendorFieldContainer = styled.div`
    padding-right: 20px;
    min-width: 25%;
    max-width: 75%;
`;

export const StyledCurrencyDisclaimer = styled(CurrencyDisclaimerLegacy)`
    margin-top: 5px;
`;

export const StyledExchangeRateWithUpdate = styled(ExchangeRateWithUpdate)`
    margin-top: 5px;
`;

export const AddressField = styled(Field)`
    padding-right: 20px;
    min-width: 25%;
    max-width: 25%;
`;
